import { render } from "./VideoProgress.vue?vue&type=template&id=299d05fa&scoped=true"
import script from "./VideoProgress.vue?vue&type=script&lang=ts"
export * from "./VideoProgress.vue?vue&type=script&lang=ts"

import "./VideoProgress.vue?vue&type=style&index=0&id=299d05fa&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-299d05fa"

export default script